module.exports = __webpack_public_path__ + "img/perah_no.9fc96bda.png";